let mouseIsDown = false

function dispatch(touchEventType: string, target: HTMLElement) {
  return function (event: MouseEvent) {
    if (touchEventType === 'touchstart') {
      mouseIsDown = true
    } else if (touchEventType === 'touchend') {
      mouseIsDown = false
    }

    if (!mouseIsDown && touchEventType === 'touchmove') {
      return
    }

    let touchEvent: TouchEvent

    try {
      const touchEvent = document.createEvent('UIEvent')
      touchEvent.initEvent(touchEventType, true, true)

      const touches = [
        {
          target: event?.target,
          identifier: 1,
          clientX: event.clientX,
          clientY: event.clientY,
          pageX: event.pageX,
          pageY: event.pageY,
          screenX: event.screenX,
          screenY: event.screenY
        }
      ]

      if (touchEventType === 'touchend') {
        touches.length = 0
      }

      Object.defineProperties(touchEvent, {
        changedTouches: { value: touches },
        targetTouches: { value: touches },
        touches: { value: touches }
      })

      target.dispatchEvent(touchEvent)
    } catch (err) {
      // failed to create a mouse event just ignore
      return
    }
  }
}

function simulate(element: HTMLElement) {
  element.addEventListener('mousedown', dispatch('touchstart', element))
  element.addEventListener('mousemove', dispatch('touchmove', element))
  document.body.addEventListener('mouseup', dispatch('touchend', element))
}

function addTouch(element: HTMLElement, x: number, y: number) {
  const evt = new MouseEvent('mousedown', {
    view: window,
    bubbles: true,
    cancelable: true,
    clientX: x,
    clientY: y,
    screenX: x,
    screenY: y
  })
  dispatch('touchstart', element)(evt)
}

export default { simulate, addTouch }
